<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="用户账号" prop="idOrName" style="width: 80%">
                <el-input
                  v-model="searchForm.idOrName"
                  placeholder="请输入用户账户"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="角色名称" prop="userName" style="width: 80%">
                <el-input
                  v-model="searchForm.userName"
                  placeholder="请输入角色名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="昵称" prop="nickName" style="width: 80%">
                <el-input
                  v-model="searchForm.nickName"
                  placeholder="请输入昵称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addUser"
          style="width: 90px"
          >新增</el-button
        >
        <el-button
          size="small"
          @click="onLoad(1)"
          type="primary"
          icon="el-icon-search"
          style="width: 90px"
          >搜索</el-button
        >
        <el-button
          size="small"
          @click="restSearch"
          type="danger"
          style="width: 90px"
          >重置</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="account" label="账号" align="center">
        </el-table-column>
        <el-table-column prop="nickName" label="昵称" align="center">
        </el-table-column>
        <el-table-column prop="roleName" label="角色名称" align="center">
        </el-table-column>

        <!-- <el-table-column prop="phone" label="手机号"  align="center">
            </el-table-column> -->
        <el-table-column prop="status" label="是否禁用" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="updataStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="lockStatus" label="用户解锁/上锁" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.lockStatus"
              @change="updateLockStates(scope.row)"
            ></el-switch>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="status"
          label="是否在线"
          align="center"
          :formatter="onlineStatus"
        ></el-table-column> -->
        <el-table-column fixed="right" align="center" label="操作" >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="updata(scope.row)"
              >修改</el-button
            >
            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
            <el-button @click="resetPsw(scope.row)" type="text" size="small"
              >重置密码</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%" :close-on-click-modal='false' @close="close">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-form-item label="头像" prop="headUrl">
              <upload
                :url.sync="addData.headUrl"
                :src="addData.headUrl"
                type="img"
              ></upload>
              <div style='color:red;'>*建议图片上传尺寸（50 * 50）</div>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名" prop="userName">
                <el-input
                  v-model="addData.userName"
                  placeholder="请输入姓名"
                  maxlength="20"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="昵称" prop="nickName">
                <el-input
                  v-model="addData.nickName"
                  placeholder="请输入昵称"
                  maxlength="20"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="isShowLabel">
            <el-col :span="12">
              <el-form-item label="账号" prop="phone">
                <el-input
                  v-model="addData.phone"
                  placeholder="请输入账号"
                  maxlength="20"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否启用" prop="status">
                <el-select
                  clearable filterable
                  v-model="addData.status"
                  placeholder="请选择状态"
                  style="width: 100%"
                >
                  <el-option label="正常" value="1"></el-option>
                  <el-option label="禁用" value="-1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="密码" prop="password">
                <el-input
                  type="password"
                  show-password
                  v-model="addData.password"
                  placeholder="请输入密码"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="角色信息" prop="roleId">
                <el-select
                  clearable filterable
                  v-model="addData.roleId"
                  placeholder="请选择角色信息"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in roleList"
                    :key="index"
                    :label="item.roleName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="选择小区" prop="villageIds">
                <el-select
                  clearable filterable
                  v-model="addData.villageIds"
                  multiple
                  placeholder="请选择选择小区"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in villageList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>          
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="close()">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import reg from "@/utils/reg";
import upload from "../../components/upload";
export default {
  components: {
    upload,
  },
  data() {
    return {
      searchForm: {
        idOrName: "",
        nickName: "",
        userName: "",
      },
      modalTitle: "新增",
      isShowLabel: true, //修改的时候为false  无法修改账号密码
      roleList: [], //角色信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        userName: "", //姓名
        nickName: "", //昵称
        phone: "", //手机号码
        email: "", //邮箱
        account: "", //账号
        password: "", //密码
        status: "1", //状态 1正常 -1 冻结
        roleId: "", //角色信息
        villageIds:[]
      },
      villageList:[],
      addDataRules: {
        userName: [
          { required: true, message: "请输入您的姓名", trigger: "blur" },
        ],
        nickName: [
          { required: true, message: "请输入昵称", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入账号", trigger: "blur" },
          {
            validator: function (rule, value, callback) {
              if (!reg.mobile(value)) {
                callback(new Error("请输入正确的手机号"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        // password: [
          // { required: true, message: "请输入密码", trigger: "blur" },
          // {
          //   validator: function (rule, value, callback) {
          //     if (!reg.passWord(value)) {
          //       callback(
          //         new Error("须包含大写(小写)字母和数字,长度在8到16个字符")
          //       );
          //     } else {
          //       callback();
          //     }
          //   },
          //   trigger: "blur",
          // },
        // ],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
        roleId: [
          { required: true, message: "请选择角色信息", trigger: "change" },
        ],
        villageIds: [
          { required: true, message: "请选择小区", trigger: "change" },
        ]
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
    };
  },
  mounted() {
    this.onLoad();
    this.$Apis.getRoleList().then((res) => {
      if (res.code == 200) {
        this.roleList = res.data
      }
    });
  },
  methods: {
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 重置密码
    resetPsw(row) {
      this.$confirm("您确定要重置吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$Apis.resetPsw({ userId: row.id }).then((res) => {
            if (res.code == 200) {
              this.$message.success("重置密码");
              this.$alert(res.data, "账号密码", {
                confirmButtonText: "复制",
                center: true,
                callback: (action) => {
                  if (action === 'confirm') {
                    this.copyText(res.data);
                  }
                  this.onLoad();
                },
              });
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
    },
    // 使用 Clipboard API 复制文本
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$message.success('复制成功');
      } catch (err) {
        // 如果 Clipboard API 不可用，使用传统方法
        this.fallbackCopyTextToClipboard(text);
      }
    },

    // 传统复制方法（兼容性更好）
    fallbackCopyTextToClipboard(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message.success('复制成功');
        } else {
          this.$message.error('复制失败');
        }
      } catch (err) {
        this.$message.error('复制失败');
      }
      document.body.removeChild(textarea);
    },
    //   删除用户
    del(row) {
      this.$confirm("您确定要删除该用户吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$Apis.delUser({ id: row.id }).then((res) => {
            if (res.code == 200) {
              this.$message.success("删除成功");
              this.onLoad();
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
    },
    // 修改用户状态
    updateLockStates(row) {
      this.$Apis
        .updateLockStates({
          id: row.id,
          lockStatus: row.lockStatus == true ? 2 : 1,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("操作成功");
          } else {
            this.$message.warning(res.msg);
          }
          this.onLoad();
        });
    },
    // 修改用户状态
    updataStatus(row) {
      this.$Apis
        .upUserState({
          id: row.id,
          status: row.status == true ? -1 : 1,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("操作成功");
          } else {
            this.$message.warning(res.msg);
          }
          this.onLoad();
        });
    },
    userStatus(row) {
      if (row.status == "1") {
        return "正常";
      } else {
        return "冻结";
      }
    },
    lockStatus(row) {
      if (row.lockStatus == "1") {
        return "正常";
      } else {
        return "已上锁";
      }
    },
    onlineStatus(row) {
      if (row.onlineStatus == "1") {
        return "在线";
      } else {
        return "离线";
      }
    },
    // 新增用户
    addUser() {
      this.isShowLabel = true;
      this.modalTitle = "新增";
      this.isAddModal = true;
      for (let item in this.addData) {
       this.addData[item] = "";
      }
      this.addData.villageIds = []
    },
    close(){ 
      this.isAddModal = false;
      for (let item in this.addData) {
       this.addData[item] = "";
      }
      this.addData.villageIds = []
      this.$refs["form"].resetFields();
      
    },
    updata(row) {
      this.isShowLabel = false;
      this.modalTitle = "修改";
      this.isAddModal = true;
      this.addData = JSON.parse(JSON.stringify(row))
      this.addData.status = this.addData.status == true ? "-1" : "1"
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          if (this.isShowLabel) {
            let data = JSON.parse(JSON.stringify(this.addData)) ;
            data.villageIds = data.villageIds.join(',')
            this.$Apis.addUserInfo(data).then((res) => {
              this.btnLoading = false;
              if (res.code == 200) {
                close()
                this.isAddModal = false;
                this.$alert(res.data, "账号密码", {
                  confirmButtonText: "复制",
                  center: true,
                  callback: (action) => {
                    if (action === 'confirm') {
                      this.copyText(res.data);
                    }
                    this.onLoad();
                  },
                });
                this.$message.success("操作成功");
              } else {
                this.$message.warning(res.msg);
              }
            });
          } else {
            let data = this.addData;
             data.villageIds = reg.array(data.villageIds) && data.villageIds.join(',') || data.villageIds
            this.$Apis.updataUser(data).then((res) => {
              this.btnLoading = false;
              if (res.code == 200) {
                close()
                this.isAddModal = false;
                this.onLoad();
                this.$message.success("操作成功");
              } else {
                this.$message.warning(res.msg);
              }
            });
          }
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad(ind) {
      this.isShowloading = true;
      this.currentPage = ind == 1 ? 1 : this.currentPage
      let page = {
        current: this.currentPage,
        size: this.pageSize,
        ...this.searchForm,
      };
      this.$Apis.villageListAll().then(res=>{
        if(res.code == 200){
          this.villageList = res.data
        }else{
          this.$message.warning(res.msg)
        }
      })
      this.$Apis.getUserList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item) => {
            item.status = item.status == -1 ? true : false;
            item.lockStatus = item.lockStatus == 2 ? true : false;
            item.villageIds = item.villageIds && item.villageIds.split(',')
            item.villageIds = item.villageIds && item.villageIds.map(Number)
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
</style>